import $ from 'jquery';
import * as globalUtils from '../../Global/global_js';
var dv_account_guid = "";
var video_guid = "";
// insert new chat message
export function add_new_chat(t, event)
{
    try
    {
        dv_account_guid = t.props.videoData.userGuid;
        video_guid = t.props.videoData.videoGuid;
        if (t.props.chat_user_info === null && dv_account_guid === "")
        {
            t.props.onShowGoogleLogin(t,event);
        }

        else
        {
            var message = event.message.text;
            if (message != "")
            {
                var id = (t.props.chat_user_info.id === undefined ? t.props.chat_user_info.account_id : t.props.chat_user_info.id);
                var name = (t.props.chat_user_info.name === undefined ? t.props.chat_user_info.firstname + " " + t.props.chat_user_info.lasttname : t.props.chat_user_info.name);
                var chat_info =
                {
                    video_guid: t.props.videoData.videoGuid,
                    chat_message: message,
                    username: name,
                    user_guid: t.props.chat_user_info.account_guid,
                    thumbnail: t.props.chat_user_info.avatar,
                    account_id: id,
                    message_time: event.message.timestamp
                };

                $.ajax({
                    url: "/api/HData/add_chat/data",
                    type: 'POST',
                    data: JSON.stringify(chat_info),
                    async: false,
                    contentType: 'application/json',
                    dataType: "text",
                    success: function (response)
                    {
                        add_new_chat_success(t, response, event);

                    }
                    , error: function (response) { add_new_chat_error(response); }

                });
            }

        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("live_chat.js",
            "add_new_chat",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}

// if new chat inserted will refresh the chat section
function add_new_chat_success(t, response, event)
{
    try
    {

        if (response == "true")
        {
            t.setState((prevState) =>
            {
                return { chat_messages: [...prevState.chat_messages, event.message] };
            });
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("live_chat.js",
            "add_new_chat_success",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}

function add_new_chat_error(ex)
{
    globalUtils.send_error_fun("live_chat.js",
        "add_new_chat_error",
        ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
}

export function load_chat(t)
{
    try
    {
        if (t.props.videoData !== undefined)
        {
            var chat_info =
            {
                video_guid: t.props.videoData.videoGuid
            };

            $.ajax({
                url: "/api/HData/get_chat/data",
                type: 'POST',
                data: JSON.stringify(chat_info),
                async: true,
                contentType: 'application/json',
                dataType: "json",
                success: function (response)
                {
                    load_chat_success(t, response);
                },
                error: function (response)
                {
                    load_chat_error(t, response);
                }
            });
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("live_chat.js",
            "load_chat",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function load_chat_success(t, response)
{
    try
    {
        if (response && response.length > 0)
        {
            var lst_msgs = [];
            var date;
            $.each(response, function (index, Message)
            {
                date = new Date(Date.parse(Message.message_time));
                //if (Message.user_guid !== t.props.chat_user_info.account_guid)
                //{
                //    id = Message.account_id;
                //}
                lst_msgs.push({
                    author: { name: Message.username, account_guid: Message.user_guid, id: Message.account_id },
                    text: filter_special_chars_chat(Message.chat_message),
                    timestamp: date

                })
            })
            t.setState({ chat_messages: lst_msgs })
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("live_chat.js",
            "load_chat_success",
            ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
    }
}
function load_chat_error(t, ex)
{
    globalUtils.send_error_fun("live_chat.js",
        "load_chat_error",
        ex, localStorage.getItem("error_info") + "&video_guid=" + video_guid);
}
function filter_special_chars_chat(str)
{
    if (str !== undefined && str != null)
    {
        return str.replace(/&/g, '&amp;')
            .replace(/<br \/>/g, '&brofchat;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/'/g, '&#39;')
            .replace(/"/g, '&#34;')
            .replace(/&brofchat;/g, '<br />');
    }
    return "";
}